import { useCallback } from 'react';
import {
  DialogTitle as MuiIDialogTitle,
  DialogTitleProps as MuiDialogTitleProps,
} from '@mui/material';
import { Typography } from '../Typography/Typography';
import { styled, SxProps, Theme } from '@mui/material/styles';
import { TypographyProps } from '@mui/material/Typography';
import { Cross } from '@bolteu/kalep-react-icons';
import { IconButton } from '../IconButton/IconButton';
import { DialogOnClose } from '../Dialog/Dialog';

export interface DialogTitleProps extends MuiDialogTitleProps {
  onClose?: DialogOnClose;
  variant?: TypographyProps['variant'];
  sx?: SxProps<Theme>;
}

const StyledDialogTitle = styled(MuiIDialogTitle)<DialogTitleProps>(() => ({
  padding: '0 24px 16px 24px',
  gap: '24px',
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'space-between',
}));

export function DialogTitle({ children, onClose, variant, sx, ...props }: DialogTitleProps) {
  const onClickClose = useCallback(() => onClose?.({}, 'closeButton'), [onClose]);

  const titleVariant = variant || 'heading-xs-accent';

  return (
    <StyledDialogTitle {...props} component={'span'}>
      <Typography variant={titleVariant} sx={sx}>
        {children}
      </Typography>
      {onClose && (
        <IconButton aria-label="close" onClick={onClickClose} color="secondary" size="small">
          <Cross />
        </IconButton>
      )}
    </StyledDialogTitle>
  );
}
